import * as React from "react"
import { connect, Provider } from "react-redux"
import trans from "trans"
import Mergado from "app/helpers/mergado"

import {
    Grid,
    GridCell,
    DataRow,
    DataCell,
    Theme,
    Icon,    
    Button,
    css,
    modal,
    Spinner,
    LittleStatus,
} from "@bdfx/mergado-ui-kit"

import { URL } from "app/config/api-config";
import {
    getTemplate,
    isGodModeOn,
    isLocalhost,
    MERGADO_APP,
    updateTemplateFieldValue,
} from "app/helpers/api";

import { renderItemId, renderName } from "./product-table";
import _map from "lodash/map";
import { DarkGrayColor } from "app/helpers/colors";
import { ExtendedProductType, ProductTemplateType } from "../types";
import VisualSimilarityRender from "./visual-similarity-render"
import { ShowGroupType } from "diagnostics/diagnostics"
import VisualSimilarity from "template-edit/components/visual-similarity"
import store from "store"
import { iconDisabledColor } from "template-edit/components/tools-panel"
import { ID } from "@bdfx/mergado-ui-kit/lib/helpers/types"
import { AxiosResponse } from "axios"
import { Template } from "app/types/model-types"
import { setTemplatesToStore } from "template-edit/reducers"
import productFilters from "./product-filters"
import { TemplateBadges } from "template-list/template-badges"

interface Props {
    product: ExtendedProductType
    groupNames: ShowGroupType[]
    copyToClipboard: Function
    copiedToClipboard: number | string | null  //ID of element which was copied into clipboard
    showModal: Function
    getEmptyFiltersForm: Function
    idx: number
    showAlternativeImages: boolean
    userId: number
}

/* interface State {
    template: ProductTemplateType
} */

class VisualSimilarityTableRow extends React.Component<Props> {
    constructor(props: Props) {
        super(props)

        /* this.state = {
            template: props.product.template
        } */
    }

    updateTemplateFieldValue = (templateId: ID, updateValues: object) => {
        /* 
        const { template } = this.state         
        this.setState({ template: { 
                ...template, 
                ...updateValues 
            } 
        }) 
        */
        
        updateTemplateFieldValue(templateId, updateValues)
            .then((response: AxiosResponse<Template[]>) => {
                store.dispatch(setTemplatesToStore(response.data))
            })
            .catch((e) => console.error('cannot update value', e))
    }

    render() {
        const { product, idx, groupNames } = this.props
        /* const { template } = this.state */

        const template = product.template

        const mergadoProductUrl = `${MERGADO_APP}/${product.product_id}`
        const previewUrl = `${URL.laravelBase}images?template_id=${product.template_id}&product_id=${product.product_id}&nocache=0`
        const templatePreviewUrl = `${URL.laravelBase}images/thumbs/thumbnail${product.template_id}.${template.is_anim_gif ? 'gif' : 'png'}`
        const emptyImages = groupNames.includes('empty_images')

        return (
            <DataRow dataId={`product-${product.product_id}`} key={`product-${product.product_id}`}>
                {(isGodModeOn || isLocalhost) &&
                    <DataCell>{product.image_id}</DataCell>
                }

                {!emptyImages &&
                    <DataCell key={'status_code'} className='centered'>
                        {product.image_status_code > 0 &&
                            trans('status_' + product.image_status_code + '_' + product.image_error_code)
                        }
                    </DataCell>
                }

                <DataCell className='clickable centered' onClick={() => this.props.showModal(idx)}>
                    {product.image_link !== '' ?
                        <img src={product.image_link} height={50} /> :
                        trans('no_image')
                    }
                </DataCell>

                <DataCell className='clickable incognito' onClick={() => Mergado.openWindow(product.elements_url)}>
                    {renderName(product.elements_name)}
                    <br />
                    {renderItemId(product.elements_item_id)}
                </DataCell>

                <DataCell style={{ textAlign: 'center' }}>
                    <Grid cols={'max-content max-content'}>
                        <GridCell>
                            <img src={templatePreviewUrl} height={50} title={`${trans('template')} ${product.template_id}`} />
                            {template && <TemplateBadges template={template} showIcons={false}  />}
                        </GridCell>
                        <GridCell style={{ textAlign: 'left' }}>
                            <LittleStatus type={template.visual_similarity_enabled ? 'success' : 'warning'}>
                                {trans(template.visual_similarity_enabled ? 'feature_enabled' : 'feature_disabled')}
                            </LittleStatus>

                            {/* {template.visual_similarity_enabled &&
                                <div>
                                    <div>{trans('visual_similarity_n')}: {template.visual_similarity_n}</div>
                                    <div>{trans('visual_similarity_threshold')}: {template.visual_similarity_threshold}</div>
                                    <div>{trans('templates')}: {template.visual_similarity_templateids}</div>
                                </div>
                            } */}

                            {/* {template &&
                                <Button
                                    type={'void'}
                                    color={'nocolor'}
                                    size={'small'}
                                    icon={<Icon type={'settings-light'} size={24} color={template.visual_similarity_enabled ? Theme.steelblue : iconDisabledColor} />}
                                    onClick={() => {
                                        modal({
                                            overlayClassName: 'visual-similarity-settings-modal',
                                            title: <Icon type={'settings-light'} size={28} text={trans("visual_similarity")} />,
                                            style: { minHeight: '60vh', minWidth: '60vw' },
                                            message: (close) => <Provider store={store}>
                                                <VisualSimilarity
                                                    templateId={template.id}
                                                    productId={product.product_id}
                                                    enabled={template.visual_similarity_enabled}
                                                    n={template.visual_similarity_n}
                                                    threshold={template.visual_similarity_threshold}
                                                    templateids={template.visual_similarity_templateids}
                                                    updateTemplateFieldValue={this.updateTemplateFieldValue}
                                                    publishAutomatically={false}
                                                />
                                            </Provider>,
                                        })
                                    }}
                                />
                            }            */}       
                        </GridCell>
                    </Grid>
                </DataCell>

                <DataCell style={{ textAlign: 'center' }}>
                    <VisualSimilarityRender product={product} template={template} />
                </DataCell>

                <DataCell key={'links'} className='centered clickable'>
                    <Grid cols={`repeat(5, 1fr)`} className={'product-links'}>
                        {product.image_link &&
                            <GridCell className='clickable'>
                                <div onClick={() => Mergado.openWindow(product.image_link)} title={trans("link_image_url")}>
                                    <Icon type={'file-image-o'} color={Theme.blue} size={20} />
                                </div>
                            </GridCell>
                        }
                        {previewUrl &&
                            <GridCell className='clickable'>
                                <div onClick={() => Mergado.openWindow(previewUrl)} title={trans("link_fie")}>
                                    <Icon type={'feedimageeditor'} size={20} />
                                </div>
                            </GridCell>
                        }
                        {mergadoProductUrl &&
                            <GridCell className='clickable'>
                                <div onClick={() => Mergado.openWindow(mergadoProductUrl)} title={trans("link_mergado")} >
                                    <Icon type={'mergado'} size={20} />
                                </div>
                            </GridCell>
                        }
                        {product.elements_url &&
                            <GridCell className='clickable'>
                                <div onClick={() => Mergado.openWindow(product.elements_url)} title={trans("link_eshop")}>
                                    <Icon type={'shopping-basket'} color={DarkGrayColor} size={20} />
                                </div>
                            </GridCell>
                        }
                        {product.elements_ean &&
                            <GridCell className='clickable'>
                                <div onClick={() => Mergado.openWindow(`https://www.barcodelookup.com/${product.elements_ean}`)} title={trans("barcode_lookup")} >
                                    <Icon type={'barcode'} color={DarkGrayColor} size={20} />
                                </div>
                            </GridCell>
                        }
                    </Grid>
                </DataCell>
            </DataRow>
        )
    }
}

export default VisualSimilarityTableRow